const SESSION_FLAG_KEY = "searchStateAtom_session_active";
const STORAGE_PREFIX = "recoil_state_";

export const checkAndResetSearchStateAtomOnTabClose = (): void => {
  if (typeof window === "undefined" || typeof sessionStorage === "undefined") {
    return;
  }

  try {
    const sessionActive = sessionStorage.getItem(SESSION_FLAG_KEY);

    if (!sessionActive) {
      try {
        const storageKey = `${STORAGE_PREFIX}searchStateAtom`;
        localStorage.removeItem(storageKey);
      } catch (error) { }
    }

    sessionStorage.setItem(SESSION_FLAG_KEY, "true");
  } catch (error) { }
};

let listenerSetup = false;

export const setupSearchStateAtomTabCloseListener = (): void => {
  if (typeof window === "undefined" || listenerSetup) {
    return;
  }
  
  listenerSetup = true;
};

